function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-announcement-views-state_svg__paint0_linear_1473_5903)",
  d: "M18 24h164v91H18z"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-announcement-views-state_svg__filter0_d_1473_5903)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 156,
  height: 70,
  rx: 2,
  transform: "matrix(1 0 0 -1 10 102)",
  fill: "#fff"
}));
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 40,
  width: 86,
  height: 14,
  rx: 2,
  fill: "#DBDFE5"
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 50.018,
  y: 43,
  width: 78.456,
  height: 8,
  rx: 2,
  fill: "#fff"
});
var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 47,
  r: 9.692,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 1.385
});
var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 47,
  r: 9,
  fill: "#DBDFE5"
});
var _ref8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-announcement-views-state_svg__b)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 56,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 44.136,
  r: 4.345,
  stroke: "#DBDFE5",
  strokeWidth: 1.325
}));
var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 135.75,
  y: 88.75,
  width: 1.5,
  height: 4,
  rx: 0.25,
  stroke: "#DBDFE5",
  strokeWidth: 0.5
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  d: "M141.898 92.377c-.14.159-.366.268-.676.326a3.993 3.993 0 01-1.061.024c-.687-.062-1.404-.235-1.911-.374V89.33c.074-.095.172-.191.296-.3.047-.042.099-.087.155-.134.109-.093.23-.196.345-.304.362-.34.736-.788.944-1.495a.487.487 0 01.238-.315.62.62 0 01.375-.054c.141.02.27.075.358.144.093.071.11.13.11.155 0 .11-.021.278-.051.487l-.022.152c-.024.16-.05.332-.069.493a2.668 2.668 0 00-.017.6.646.646 0 00.091.272c.067.1.176.172.318.173.115 0 .261-.018.403-.037l.098-.013c.117-.016.235-.032.351-.043.149-.015.278-.02.378-.012.082.008.111.023.115.025a.364.364 0 01.049.13c.019.083.032.192.034.326.006.267-.027.602-.097.957-.14.721-.416 1.457-.754 1.84z",
  stroke: "#DBDFE5",
  strokeWidth: 0.5
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.157 90a5.627 5.627 0 01-10.314 0 5.626 5.626 0 0110.314 0z",
  fill: "#0085FF"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M154 91.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
  fill: "#fff"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#A0AFBE",
  d: "M23 61h137v6H23zM23 70h137v6H23zM23 79h69v6H23z"
});
var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-announcement-views-state_svg__paint0_linear_1473_5903",
  x1: 95.591,
  y1: 64.349,
  x2: 11.828,
  y2: 64.349,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "empty-announcement-views-state_svg__filter0_d_1473_5903",
  x: 2,
  y: 26,
  width: 172,
  height: 86,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1473_5903"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_1473_5903",
  result: "shape"
})));
function SvgEmptyAnnouncementViewsState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 140,
    fill: "none"
  }, props), _ref, /*#__PURE__*/React.createElement("mask", {
    id: "empty-announcement-views-state_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 24,
    width: 164,
    height: 91
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#empty-announcement-views-state_svg__a)"
  }, _ref3, _ref4, _ref5, _ref6, /*#__PURE__*/React.createElement("mask", {
    id: "empty-announcement-views-state_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 38,
    width: 18,
    height: 18
  }, _ref7), _ref8, _ref9, _ref0, _ref1, _ref10, _ref11), _ref12);
}
export default SvgEmptyAnnouncementViewsState;